import { ApiMethod } from 'services/api';
import {
  useRestMutation,
  useRestQuery,
  UseRestMutationOptions,
  RestQueryHookOptions,
} from 'utils/hooks/api';

const ORG_AUTH_METHODS_URL = '/i/orgs/current/authMethods';

export const useOrgAuthMethods = (
  params?: Record<string, unknown>,
  options?: RestQueryHookOptions,
) => useRestQuery(ORG_AUTH_METHODS_URL, params, options);

export type OrgAuthMethods = {
  googleAuthEnabled: boolean;
  samlAuthEnabled: boolean;
  userPassAuthEnabled: boolean;
};

export const useUpdateOrgAuthMethods = (options?: UseRestMutationOptions) =>
  useRestMutation(ORG_AUTH_METHODS_URL, ApiMethod.post, options);
